import { DataBean } from "../DataBean";

export class TransportGuidePaymentForm extends DataBean {

    public async getTransportGuidePaymentFormCatalog(idTransportGuide: number, transportGuideDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTransportGuidePaymentFormCatalog_Number_java.util.Date", [idTransportGuide, transportGuideDate]);
    }

    public async addTransportGuidePaymentForm(idTransportGuide: number, transportGuideDate: any, idUBLPaymentMeansCode: number, value: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.transportguides.TransportGuidePaymentForm_addTransportGuidePaymentForm_Number_java.util.Date_Number_Number", [idTransportGuide, transportGuideDate, idUBLPaymentMeansCode, value]);
    }

    public async deleteTransportGuidePaymentForm(transportGuideDate: any, idTransportGuidePaymentForm: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore",
            "void_deleteTransportGuidePaymentForm_java.util.Date_Number",
            [transportGuideDate, idTransportGuidePaymentForm]);
    }

    public async updateTransportGuidePaymentForm(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.transportguides.TransportGuidePaymentForm_updateTransportGuidePaymentForm_com.quickdataerp.bean.transportguides.TransportGuidePaymentForm",
            [
                {
                    "DataBeanProperties": bean,
                    "DataBeanName": "com.quickdataerp.bean.transportguides.TransportGuidePaymentForm"
                }
            ]
        )
            ;
    }

}
